import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Projects from "./components/sections/Projects";
import Contact from "./components/sections/Contact";
import Loading from "./components/common/Loading";
import "./index.css";
import "./App.css";
import Dither from "./components/background/Dither";

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulate loading
      setIsLoading(false);
      setFadeIn(true);
      setTimeout(() => {
        setShowLoading(false);
      }, 700);
    };
    loadData();
  }, []);

  return (
    <>
      {showLoading && (
        <div
          className={`fixed inset-0 flex justify-center items-center bg-black transition-opacity duration-700 ${
            fadeIn ? "opacity-0" : "opacity-100"
          } z-50`}
          aria-label="Loading"
        >
          <Loading />
        </div>
      )}

      {/* Shader background (fullscreen, behind content) */}
      <Dither
        waveColor={[0.4, 0.4, 0.3]}
        disableAnimation={false}
        enableMouseInteraction={true}
        mouseRadius={0.3}
        colorNum={10}
        waveAmplitude={0.25}
        waveFrequency={2}
        waveSpeed={0.06}
      />

      {/* Main content (scrollable, interactive, fades in, may have bg) */}
      {!isLoading && (
    <div
      className={`absolute inset-0 transition-opacity duration-700 ease-in-out overflow-auto ${
        fadeIn ? "opacity-100" : "opacity-0"
      }`}
    >
      <Router>
        <div className="flex-1 flex flex-col justify-center items-center">
          <Header />
          <Hero/>
          <main>
            <Routes>
              <Route path="/" element={<Hero />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
        </div>
      </Router>
    </div>
  )}
    </>
  );
};

export default App;
